import './style.css'
import { createRoot } from 'react-dom/client'
import Experience from './Experience.js'
import React from 'react'


createRoot(document.getElementById('root')).render(
<>
<Experience/>
</>
)



//Alternativ method for rendering:

// const root = ReactDOM.createRoot(document.querySelector('root'))



// root.render(
//     <Canvas
//         camera={ {
//             fov: 45,
//             near: 0.1,
//             far: 2000,
//             position: [ -3, 1.5, 4 ]

//         } }
//         flat    
//     >
//         <Experience />
//         <Perf position="top-left"/>

//     </Canvas>
// )